// libraries
import type { AltDealStructureState } from '@makemydeal/dr-dash-types';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { createSelector } from 'reselect';

export const getAltDealStructureState = (state: StateTree): AltDealStructureState =>
    state.altDealStructure ?? { isStale: true, lastFetchedAt: null };

export const shouldFetchAltDealStructures = createSelector(
    [getAltDealStructureState],
    (state): boolean => state.isStale || state.lastFetchedAt === null
);
